<template>
  <div class="ma-0 pa-0" :class="isOnMobile ? 'box-container' : 'box-container-horizontal'" style="width: 100%; height: 100%" :style="isOnMobile ? 'flex-direction: column-reverse;' : ''">
    <div class="row-header ma-0 pa-0">
      <device-list
        class="ma-0 pa-0 px-1"
        v-model="selectedDev"
        :showAll="true"
        :devices="getDevices"
        :width="isOnMobile ? '100%' : 270"
        :height="isOnMobile ? 300 : '100%'"
        :slotHeight="(datatype && datatype.require_choice) || euroFilter ? 40 : 0"
        @click="(item) => convertDataToChartData()"
        @datesChanged="
          (dates) => {
            datatype.datesFromTo = dates;
            $router.loadRouteData(route, true);
          }
        "
      >
        <template slot="top">
          <t-date-range-input
            v-if="datatype && datatype.require_choice"
            style="width: 260px; max-width: 270px"
            class="ma-1 mb-0 pa-0 subtitle-2"
            v-model="datatype.datesFromTo"
            :label="TR.Period"
            :clearable="false"
            @click="$router.loadRouteData(route, true)"
          ></t-date-range-input>
          <template v-else-if="euroFilter">
            <v-row class="ma-0 pa-0">
              <v-text-field disabled readonly hide-details dense class="subtitle-2" style="width: 140px; max-width: 140px" :label="euroFilter.text"> </v-text-field>
              <v-select
                class="ma-1 mb-0 pa-0 subtitle-2"
                v-model="euroFilter.vals[0]"
                return-object
                @change="appendFilter(euroFilter)"
                :items="getFiltersUniqueValues(euroFilter)"
                dense
                :no-data-text="TR.NoData"
                :item-color="isInDarkMode ? '#FFFFFF' : ''"
                style="width: 110px; max-width: 120px"
              ></v-select>
            </v-row>
          </template>
        </template>
      </device-list>
    </div>
    <div class="row-content ma-0 pa-2">
      <div class="box-container ma-0 pa-0">
        <v-row class="row-header ma-2" :class="isOnMobile ? 'ma-1' : ''" justify="start" align="center"> </v-row>
        <v-row class="row-header ma-0 pa-0">
          <v-col cols="12" class="ma-0 pa-0">
            <t-filters v-if="isFilterMenuVisible" :datatype="datatype" />
          </v-col>
        </v-row>
        <div class="row-content ma-0 pa-0" style="overflow: hidden">
          <apex-chart v-if="hasData && loaded && onfocus" ref="refChart" width="100%" height="100%" :type="chartTypes[currentView].type" :series="chartSeries" :options="chartOptions"></apex-chart>
          <v-row v-else align="center" justify="center" class="ma-0 pa-0">
            <v-progress-linear v-if="!loaded" :indeterminate="true"></v-progress-linear>
            <v-alert justify="center" align="center" :class="loaded ? '' : 'subtitle-2'" :value="true" color="default" :icon="loaded ? 'mdi-emoticon-sad' : ' '">{{
              loaded ? (error_message == null ? TR.NoDataForShowing : error_message) : TR.DataProcessingPleaseWait
            }}</v-alert>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataManager, { chart_locales, ErrorMessage, DataFilterType, DataPropType } from "../js/DataManager";
import Translation from "../js/Translation";
// import { ColorPalette, g_Dialog } from "../main";
import { g_Dialog, TR } from "../main";
import bus from "../main";

export default {
  components: {},
  inject: ["theme"],
  props: {
    chartTypes: {
      type: Array,
      default: () => [
        {
          text: TR.Chart_Bar,
          type: "bar",
          stacked: false,
          icon: "mdi-chart-bar",
        },
        {
          text: TR.Chart_Line,
          type: "line",
          stacked: false,
          icon: "mdi-chart-bell-curve",
        },
        // {
        //   text: "С натрупване",
        //   type: "bar",
        //   stacked: true,
        //   icon: "mdi-chart-bar-stacked",
        // },
        {
          text: TR.Chart_Percent,
          type: "pie",
          stacked: false,
          icon: "mdi-chart-pie",
        },
      ],
    },
  },
  data() {
    return {
      datatype: null,
      route: null,
      isFilterMenuVisible: false,
      selectedDev: null,
      predefinedfilters: null,
      currentView: 0,
      chartSeries: [],
      /** @type {ApexCharts.ApexOptions} */
      chartOptions: {
        theme: {
          mode: "light",
        },
        chart: {
          selection: {
            enabled: false,
          },
          locales: chart_locales,
          defaultLocale: TR.Locale,
          id: this.zzChartId,
          type: "line",
          stacked: false,
          background: this.zzBackground,
          foreColor: this.zzForeground,
          events: {
            beforeZoom: (e, { xaxis }) => {
              //console.log(e);
              if (this.isPie()) return;

              let zoomdifference = (zoomdifference = xaxis.max - xaxis.min);
              let maindifference = 0;
              if (this.datatype == DataManager.DataType.sales_by_article_price) {
                maindifference = this.getCategories().length - 1;
              } else {
                maindifference = new Date(this.getCategories()[this.getCategories().length - 1]).valueOf() - new Date(this.getCategories()[0]).valueOf();
              }

              if (zoomdifference > maindifference)
                if (this.datatype == DataManager.DataType.sales_by_article_price) {
                  return {
                    xaxis: {
                      min: this.isPie() ? undefined : 0,
                      max: this.isPie() ? undefined : this.getCategories().length - 1,
                    },
                  };
                } else {
                  return {
                    // dont zoom out any further
                    xaxis: {
                      min: this.isPie() ? undefined : this.getCategories()[0],
                      max: this.isPie() ? undefined : this.getCategories()[this.getCategories().length - 1],
                    },
                  };
                }
              else {
                return {
                  // keep on zooming
                  xaxis: {
                    min: xaxis.min,
                    max: xaxis.max,
                  },
                };
              }
            },
            zoomed: (e, { xaxis }) => {
              if (this.isPie() || this.datatype == DataManager.DataType.sales_by_article_price) {
                return;
              }
              if (xaxis && xaxis.min && xaxis.max) {
                this.zzTickAmount = this.getCategories().filter((f) => new Date(f) >= xaxis.min && new Date(f) <= xaxis.max).length;
                //if (this.zzTickAmount > 0) this.zzTickAmount--;
              } else {
                this.zzTickAmount = this.getCategories().length > 0 ? this.getCategories().length - 1 : 0; //todo?
              }
              this.chartOptions = {
                ...this.chartOptions,
                ...{
                  xaxis: {
                    tickAmount: this.zzTickAmount,
                  },
                },
              };
              // console.log(e);
              // console.log(xaxis);
              // console.log(yaxis);
            },
            // animationEnd: function (chartContext, options) {
            //   console.log(chartContext);
            //   console.log(options);
            // },
            // beforeMount: (chartContext, config) => {
            //   // if (!chartContext.series || !chartContext.series.ctx || chartContext.series.ctx.data) {
            //   if (!config.config.series) {
            //     console.log("before mount error");
            //     console.log(config);
            //     this.OO = null;
            //     this.$nextTick(() => {
            //       this.OO = this.convertDataToChartData(this.datatype);
            //       this.refreshData(false);
            //     });
            //   }
            // },
            // mounted: (chartContext, config) =>{
            //   console.log(chartContext);
            //   console.log(config);
            // },
          },
        },
        dataLabels: {
          enabled: this.zzLabelsVisible || this.isPie(),
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          tickAmount: this.zzTickAmount,
          type: "category",
          categories: [],
          labels: {
            trim: true,
            hideOverlappingLabels: false,
            showDuplicates: false,
          },
          floating: true,
        },
        yaxis: {
          type: "number",
        },
        labels: [],
      },
      zzChartId: "TremolAssistant",
      zzTheme: "light",
      zzBackground: "#FFF",
      zzForeground: "#000",
      zzTickAmount: 10,
      zzLabelsVisible: true,
      OO: null,
      loaded: false,
      onfocus: false,
      error_message: null,
      euroFilter: null,
      TR: TR,
      Translation: Translation,
    };
  },
  methods: {
    getXaxisType() {
      if (this.isPie() || this.datatype == DataManager.DataType.sales_by_article_price) {
        return "category";
      } else if (this.datatype == DataManager.DataType.monthly || this.datatype == DataManager.DataType.daily_reports || this.datatype == DataManager.DataType.sales_by_payments) {
        return "datetime";
      } else {
        return "numeric";
      }
    },
    showTypePicker() {
      g_Dialog.show(
        g_Dialog.dialog_types.picker,
        this.chartTypes,
        {
          title: TR.Chart_View + ":",
          selected: this.chartTypes[this.currentView],
          width: "400px",
          hideSearch: true,
          toStringFn: (c) => {
            return c.text;
          },
        },
        (res) => {
          if (res) {
            this.currentView = this.chartTypes.indexOf(res);
          }
        }
      );
    },
    /**
     * @param {DataManager.DataType} datatype
     * @param {ErrorMessage} err
     */
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      this.zzTitle = meta.title;
      this.route = meta.route;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.predefinedfilters = DataManager.filters_predefined[this.datatype.id];
        this.predefinedfilters.forEach((f) => {
          if (f.vals && f.vals[0] != null) {
            DataManager.setFilters(this.datatype, [f]);
            if (f.propname == "Currency") this.euroFilter = f;
          }
        });
        // if (this.datatype == DataManager.DataType.sales_by_article_price || this.datatype == DataManager.DataType.sales_by_hours_price) {
        //   this.currentView = 1;
        // }
        this.$nextTick(() => {
          this.convertDataToChartData();
        });

        //Object.freeze(this.OO);
        // setTimeout(() => {
        //   if (this.OO && this.$refs && this.$refs.refChart) {
        //     this.$refs.refChart.resetSeries(true, true);
        //     var cat = this.getCategories();
        //     if (cat.length > 10) {
        //       try {
        //         this.$refs.refChart.zoomX(new Date(cat[cat.length - 9]).getTime(), new Date(cat[cat.length - 1]).getTime);
        //       } catch {
        //         try {
        //           this.$refs.refChart.zoomX(Number(cat[cat.length - 9]), Number(cat[cat.length - 1]));
        //         } catch {
        //           this.$refs.refChart.zoomX(cat[cat.length - 9], cat[cat.length - 1]);
        //         }
        //       }
        //     }
        //   }
        // }, 1000);
      } else {
        this.error_message = error.Message;
        this.loaded = true;
        //router.push({ path: "/login", params: { errors: this.zzTitle } });
        this.dialogLoader.showError(this.error_message, { location: "center" });
      }
    },
    setFocus(on) {
      if (this.$refs.refChart && !on) {
        this.$refs.refChart.destroy();
        //console.log("destroy")
      }
      this.onfocus = on;
    },
    isPie() {
      return this.chartTypes[this.currentView] && this.chartTypes[this.currentView].type == "pie";
    },
    getIconString(icon) {
      return '<i class="v-icon notranslate mdi ' + icon + " theme--" + this.zzTheme + '" style="font-size: 32px; z-index: 13;"/></i>';
    },
    getCategories() {
      if (!this.OO) return [];
      if (this.isPie()) return this.OO.categoriesSUM;
      else return this.OO.categories;
    },
    getSeries() {
      if (!this.OO) return [];
      else if (this.isPie()) return this.OO.seriesSUM;
      else return this.OO.series;
    },
    showLabels() {
      this.zzLabelsVisible = !this.zzLabelsVisible;
    },
    refreshTheme() {
      if (this.isInDarkMode) {
        if (this.zzTheme == "dark") return;
        this.zzBackground = "#1E1E1E";
        this.zzForeground = "#FFF";
        this.zzTheme = "dark";
      } else {
        if (this.zzTheme == "light") return;
        this.zzBackground = "#FFF";
        this.zzForeground = "#000";
        this.zzTheme = "light";
      }
      this.refreshData(false);
    },
    refreshData(refreshOptionsOnly) {
      this.loaded = false;
      this.zzChartId = (this.zzTitle + "_" + new Date().toStringWithFormat("yyyyMMdd") + "_" + this.chartTypes[this.currentView].text).replaceAll(" ", "-");
      if (this.OO) {
        this.zzTickAmount = this.getCategories().length > 0 ? this.getCategories().length - 1 : 0; //todo?
        /** @type {ApexCharts.ApexOptions} */
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            legend: {
              formatter: this.isPie()
                ? function (seriesName, opts) {
                    return seriesName + " - " + (opts.w.globals.series && opts.w.globals.series.some((f) => f && f > 0) ? ((opts.w.globals.series[opts.seriesIndex] / opts.w.globals.series.sum()) * 100).toFixed(2) + "%" : "0%");
                  }
                : undefined,
              // width: 150,
              // position: 'right',
            },
            title: {
              //text: this.isOnMobile ? " " : this.zzTitle,
              align: "left",
              style: {
                fontSize: "14px",
                fontWeight: "regular",
                fontFamily: undefined,
              },
            },
            theme: {
              mode: this.zzTheme,
            },
            chart: {
              ...this.chartOptions.chart,
              ...{
                plotOptions: {
                  bar: {
                    distributed: true,
                  },
                },
                id: this.zzChartId.replaceAll("_", ""),
                defaultLocale: (() => TR.Locale)(),
                type: this.chartTypes[this.currentView].type,
                stacked: this.chartTypes[this.currentView].stacked,
                background: this.zzBackground,
                foreColor: this.zzForeground,
                animations: {
                  speed: 100,
                  animateGradually: {
                    delay: 0,
                  },
                },
                toolbar: {
                  show: true, //!this.isPie(),
                  tools: {
                    customIcons: [
                      {
                        icon: this.getIconString(this.chartTypes[this.currentView].icon),
                        index: this.isPie() ? -1 : -8,
                        title: TR.View,
                        class: "apexcharts-custom-icon",
                        click: () => {
                          this.showTypePicker();
                        },
                      },
                      ...(this.isPie()
                        ? []
                        : [
                            {
                              icon: this.getIconString(this.zzLabelsVisible ? "mdi-label-off-outline" : "mdi-label-outline"),
                              index: -1,
                              title: this.zzLabelsVisible ? TR.Chart_HideLabels : TR.Chart_ShowLabels,
                              class: "apexcharts-custom-icon",
                              click: () => {
                                this.showLabels();
                              },
                            },
                          ]),
                    ],
                    zoomin: this.getIconString("mdi-magnify-plus-outline"),
                    zoomout: this.getIconString("mdi-magnify-minus-outline"),
                    zoom: this.getIconString("mdi-magnify-scan"),
                    reset: false, //this.getIconString("mdi-home"),
                    selection: false,
                    pan: this.getIconString("mdi-cursor-move"),
                    download: this.getIconString("mdi-download"),
                  },
                  export: {
                    csv: {
                      filename: "TremolAssistant_" + this.zzChartId,
                    },
                    svg: {
                      filename: "TremolAssistant_" + this.zzChartId,
                    },
                    png: {
                      filename: "TremolAssistant_" + this.zzChartId,
                    },
                  },
                },
                // events: {
                //   beforeZoom: (e, { xaxis }) => {
                //     if (this.isPie()) return;
                //     let maindifference = new Date(this.getCategories()[0]).valueOf() - new Date(this.getCategories()[this.getCategories().length - 1].date).valueOf();
                //     let zoomdifference = xaxis.max - xaxis.min;
                //     if (zoomdifference > maindifference)
                //       return {
                //         // dont zoom out any further
                //         xaxis: {
                //           min: this.isPie() ? undefined : this.getCategories()[0],
                //           max: this.isPie() ? undefined : this.getCategories()[this.getCategories().length - 1],
                //         },
                //       };
                //     else {
                //       return {
                //         // keep on zooming
                //         xaxis: {
                //           min: xaxis.min,
                //           max: xaxis.max,
                //         },
                //       };
                //     }
                //   },
                // },
              },
            },
            // colors: ColorPalette,
            dataLabels: {
              enabled: this.zzLabelsVisible || this.isPie(),
              formatter: this.isPie()
                ? function (val) {
                    return val == null || val == undefined ? "0%" : val.toFixed(2) + "%";
                  }
                : this.OO.formatterY,
            },
            xaxis: {
              type: this.getXaxisType(),
              tickAmount: this.zzTickAmount,
              labels: {
                formatter: this.OO.formatterX,
                hideOverlappingLabels: false,
              },
              min: this.isPie() || this.getCategories().length == 0 || this.datatype == DataManager.DataType.sales_by_article_price ? undefined : this.getCategories()[0].valueOf(),
              max: this.isPie() || this.getCategories().length == 0 || this.datatype == DataManager.DataType.sales_by_article_price ? undefined : this.getCategories()[this.getCategories().length - 1].valueOf(),
              categories: this.getCategories(),
              tickPlacement: "between",
            },
            yaxis: {
              labels: {
                formatter: this.OO.formatterY,
              },
              axisBorder: {
                show: true,
                color: "#05733F",
              },
              axisTicks: {
                show: true,
                borderType: "solid",
              },
              tooltip: {
                enabled: true,
              },
            },
            tooltip: {
              //enabled: true,
              x: {
                formatter: this.OO && this.OO.formatterTooltipX,
              },
            },
            labels: this.getCategories(),
          },
        };
        if (!refreshOptionsOnly) {
          this.chartSeries = this.getSeries();
        }
      } else {
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            noData: {
              text: "",
            },
            title: {
              //text: this.isOnMobile ? " " : this.zzTitle,
              align: "left",
            },
          },
        };
      }
      this.loaded = true;

      this.$nextTick(() => {
        // setTimeout(() => {

        if (this.$refs.refChart && this.$refs.refChart.$el) {
          this.$refs.refChart.resetSeries(true, true);
          try {
            this.$refs.refChart.$el.getElementsByClassName("apexcharts-element-hidden").forEach((e) => {
              e.classList.remove("apexcharts-element-hidden");
            });
          } catch {
            /**ignored */
          }
        }
        // }, 500);
      });
    },

    async convertDataToChartData() {
      this.loaded = false;
      setTimeout(() => {
        var devs = this.selectedDev ? [this.selectedDev] : DataManager.getSubscribedDevs();
        var devsSn = devs.map((d) => d.sn);
        var data = DataManager.getData(this.datatype).filter((d) => devsSn.indexOf(d.sn) != -1);
        var series = [];
        var seriesSUM = [];
        var categories = [];
        var categoriesSUM = [];
        var formatterX = null;
        var formatterY = null;
        var formatterTooltipX = null;
        switch (this.datatype) {
          case DataManager.DataType.monthly:
            // devsSn.forEach(sn => {
            //   series.push({ name: sn, data: [] });
            // });

            formatterX = function (val) {
              if (val == null || val == undefined) return "0";
              var dt = new Date(val);
              return [DataManager.MonthNames[dt.getMonth()], dt.getFullYear()];
            };
            formatterTooltipX = formatterX;
            formatterY = function (val) {
              if (val == null || val == undefined) return "0 ";
              return val.toFixed(2);
            };

            var m_yrs = data.map((i) => i.YY);
            var m_minY = Math.min(...m_yrs);
            var m_maxY = Math.max(...m_yrs);

            series.push({ name: TR.Total, data: [] });
            for (var y = m_minY; y <= m_maxY; y++) {
              var m_mnts = data.filter((f) => f.YY == y).map((i) => i.MM);
              var m_minM = Math.min(...m_mnts);
              var m_maxM = Math.max(...m_mnts);
              var m0 = 0;
              if (y == m_minY) m0 = m_minM;
              var m1 = 11;
              if (y == m_maxY) m1 = m_maxM;
              // if (m_minY == m_maxY && m0 == m1) {
              //   if (m0 > 0) m0--;
              //   if (m1 < 11) m1++;
              // }
              for (var m = m0; m <= m1; m++) {
                var sum = data
                  .filter((e) => e.YY == y && e.MM == m)
                  .map((f) => f.Sum)
                  .sum();
                series[0].data.push(sum);
                categories.push(new Date(y, m, 15, 0, 0, 0).toUTCString()); //m + "." + y)
                categoriesSUM.push(DataManager.MonthNamesShort[m] + " " + y);
                seriesSUM.push(sum);
              }
              categoriesSUM = categoriesSUM.reverse();
            }
            break;

          case DataManager.DataType.daily_reports:
            // devsSn.forEach(sn => {
            //   series.push({ name: sn, data: [] });
            // });

            formatterTooltipX = formatterX = function (val) {
              if (val == null || val == undefined) return "0";
              return new Date(val).toTremolFpStringShort();
            };
            formatterY = function (val) {
              if (val == null || val == undefined) return "0 ";
              return val.toFixed(2);
            };

            var s_dates = [
              ...new Set(
                data.map((e) => {
                  return e.DWTT;
                })
              ),
            ];
            //.unique();

            var s_max_date = new Date(Math.max(...s_dates)).getDateWithoutTime();
            var s_min_date = new Date(Math.min(...s_dates)).getDateWithoutTime();
            if (s_min_date < s_max_date.addDays(-DataManager.daysForRequestZ)) {
              s_min_date = s_max_date.addDays(-DataManager.daysForRequestZ);
            }
            //var s_min_date = new Date(Math.min(...s_dates)).getDateWithoutTime(); // s_max_date.addDays(-30); //

            var s_data = data.filter((d) => d.date > s_min_date).sort((a, b) => b.date - a.date);
            var s_start_date = s_min_date;

            series.push({ name: TR.Total, data: [] });
            while (s_start_date <= s_max_date) {
              //console.log(s_start_date.toStringWithFormat("dd-MM-yyyy"));
              var s_start_date_time = s_start_date.getTime();
              //for (var i = series.length - 1; i >= 0; i--) {
              //var ser = series[i];
              var dailySum = s_data
                .naiveForFilter((ee) => ee.DWTT === s_start_date_time)
                .map((r) => r.Sum)
                .sum();
              series[0].data.push(dailySum);
              seriesSUM.push(dailySum);
              categories.push(s_start_date.addHours(12).toUTCString());
              categoriesSUM.push(s_start_date.toTremolFpStringShort());
              s_start_date = s_start_date.addDays(1);
            }
            categoriesSUM = categoriesSUM.reverse();

            break;

          case DataManager.DataType.sales_by_hours_qty:
          case DataManager.DataType.sales_by_hours_price:
            var daysDiff = this.datatype.datesFromTo[0].daysDiff(this.datatype.datesFromTo[1]);
            var isPrice = this.datatype == DataManager.DataType.sales_by_hours_price;
            // data = data.filter((d) => d.ReceiptType == ReceiptType.fiscalReceipt || d.ReceiptType == ReceiptType.invoice || d.ReceiptType == ReceiptType.storno);
            formatterX = function (val) {
              if (val == null || val == undefined) return "0";
              return val.toFixed(0) + " " + TR.HourAbbreviation;
            };
            formatterTooltipX = function (val) {
              if (val == null || val == undefined) return "0";
              return val.toFixed(0) + "-" + (val + 1).toFixed(0) + " " + TR.HourAbbreviation + " ";
            };
            if (isPrice) {
              if (daysDiff == 1) {
                series.push({ name: TR.Turnover, data: [] });
              } else {
                series.push({ name: TR.Turnover + " (" + TR.AverageDaily + ")", data: [] });
              }
              formatterY = function (val) {
                if (val == null || val == undefined) return "0";
                return val.toFixed(2);
              };
            } else {
              if (daysDiff == 1) {
                series.push({ name: TR.SalesCount, data: [] });
              } else {
                series.push({ name: TR.SalesCount + " (" + TR.AverageDaily + ")", data: [] });
              }
              formatterY = function (val) {
                if (val == null || val == undefined) return "0";
                return val.toFixed(3);
              };
            }

            var s_hours = [...new Set(data.map((e) => e.HH))];
            var s_min_hour = Math.min(...s_hours);
            var s_max_hour = Math.max(...s_hours);

            for (var hh = s_min_hour; hh <= s_max_hour; hh++) {
              series[0].data.push(0);
              seriesSUM.push(0);
              categories.push(hh);
              categoriesSUM.push(hh.toFixed(0) + "-" + (hh + 1).toFixed(0) + " " + TR.HourAbbreviation);
            }
            if (isPrice) {
              data.forEach((s) => {
                series[0].data[s.HH - s_min_hour] += s.Sum;
                seriesSUM[s.HH - s_min_hour] += s.Sum;
              });
            } else {
              data.forEach((s) => {
                series[0].data[s.HH - s_min_hour] += s.ItemsCount;
                seriesSUM[s.HH - s_min_hour] += s.ItemsCount;
              });
            }
            for (var i = 0; i < seriesSUM.length; i++) {
              seriesSUM[i] = seriesSUM[i] / daysDiff;
              series[0].data[i] = series[0].data[i] / daysDiff;
            }

            break;

          case DataManager.DataType.sales_by_article_price:
            formatterX = formatterTooltipX = function (val) {
              if (val == null || val == undefined) return "0";
              return val.toFixed(2);
            };
            formatterY = function (val) {
              if (val == null || val == undefined) return "0";
              return val.toFixed(3);
            };
            var a_data = data.groupByAndSum("sales_qty", "sales_price").sortBy("sales_price");
            // a_data.forEach(a => {
            //   series.push({ name: a.sales_price.toFixed(2), data: [a.sales_qty] });
            // });
            series.push({ name: TR.QuantitySold, data: [...a_data.map((s) => s.sales_qty)] });
            categories.push(...a_data.map((a) => a.sales_price));

            seriesSUM.push(...a_data.map((s) => s.sales_qty));
            categoriesSUM.push(...a_data.map((a) => a.sales_price));

            break;

          case DataManager.DataType.sales_by_payments:
            formatterX = function (val) {
              if (val == null || val == undefined) return "0";
              return new Date(val).toTremolFpStringShort();
            };
            formatterTooltipX = formatterX;
            formatterY = function (val) {
              if (val == null || val == undefined) return "0";
              return val.toFixed(2);
            };
            var p_data = data
              .map((q) => {
                return { date: q.date, payments_sum: q.payments_sum, payments_payType: q.payments_payType };
              })
              .groupByAndSum("payments_sum", "payments_payType", "date");
            // var p_dates = p_data
            //   .map(e => {
            //     return e.date;
            //   })
            //   .unique();

            var p_dates = [
              ...new Set(
                data.map((e) => {
                  return e.DWT;
                })
              ),
            ];
            //.unique();

            var p_min_date = new Date(Math.min(...p_dates));
            var p_max_date = new Date(Math.max(...p_dates));

            p_data
              .map((p) => {
                return p.payments_payType;
              })
              .unique()
              .forEach((p) => {
                series.push({ name: p, data: [] });
              });
            var p_start_date = p_min_date;
            while (p_start_date <= p_max_date) {
              const p_end_date = p_start_date.addDays(1);
              series.forEach((ser) => {
                const found = p_data.find(function (ee) {
                  return ser.name == ee.payments_payType && ee.date >= p_start_date && ee.date < p_end_date;
                });
                if (found && found.payments_sum != null) {
                  ser.data.push(found.payments_sum);
                } else {
                  ser.data.push(0);
                }
              });
              categories.push(p_start_date.addHours(12).toUTCString());
              p_start_date = p_end_date;
            }
            series.forEach((ser) => {
              seriesSUM.push(Number(ser.data.sum()));
              categoriesSUM.push(ser.name);
            });
            break;
        }
        this.OO = {
          categories: categories,
          series: series,
          categoriesSUM: categoriesSUM,
          seriesSUM: seriesSUM,
          formatterX: formatterX,
          formatterY: formatterY,
          formatterTooltipX: formatterTooltipX,
        };
        // console.log(this.OO);
        this.refreshData(false);
      }, 333);
    },
    getFiltersUniqueValues(filter) {
      return DataManager.getFilterDistinctValues(this.datatype, filter).reverse();
    },
    appendFilter(filter) {
      DataManager.appendFilter(this.datatype, filter);
    },
  },
  computed: {
    getDevices() {
      return DataManager.getSubscribedDevs();
    },
    DataFilterType() {
      return DataFilterType;
    },
    DataPropType() {
      return DataPropType;
    },
    hasData() {
      return this.OO != null && this.chartSeries.length > 0 && (!this.isPie() ? this.chartSeries[0].data && this.chartSeries[0].data.length > 0 : this.chartSeries.length > 0);
    },
  },
  updated() {
    this.refreshTheme();
  },
  created() {},
  mounted() {
    bus.$on(bus.EVENT_DataManager_FILTERS_CHANGED, async (datatype) => {
      if (datatype == this.datatype && this.onfocus) {
        this.predefinedfilters.forEach((f) => {
          var found = DataManager.getFilters(this.datatype.id).find((ff) => f.propname == ff.propname);
          if (found) {
            f.vals = found.vals;
          } else {
            f.vals = [];
          }
        });
        this.convertDataToChartData();
      }
    });
  },
  destroyed() {},
  watch: {
    currentView: {
      handler(oldVal, newVal) {
        this.refreshData(!(newVal != oldVal && (this.chartTypes[newVal].type == "pie" || this.chartTypes[oldVal].type == "pie")));
      },
    },
    zzLabelsVisible: function () {
      this.refreshData(true);
    },
  },
};
</script>
<style scoped>
div >>> .apexcharts-toolbar {
  max-width: 320px;
  width: auto;
  height: 32px;
}

div >>> .apexcharts-legend {
  padding-top: 6px;
}

div >>> .apexcharts-zoomin-icon,
div >>> .apexcharts-zoomout-icon,
div >>> .apexcharts-zoom-icon,
div >>> .apexcharts-pan-icon,
div >>> .apexcharts-reset-icon,
div >>> .apexcharts-menu-icon,
div >>> .apexcharts-custom-icon {
  height: 32px;
  width: 32px;
  margin-right: 5px;
}
</style>